import React from 'react';
import ReactSelect from 'react-select';
import PropTypes from 'prop-types';

const Select = (props) => {
  const { options, value, onChange, } = props;
  const { placeholder, } = props;
  const { isMulti, } = props;
  const { isMobile, } = props;
  return (
    <ReactSelect
      options={options}
      value={value}
      placeholder={placeholder}
      isSearchable={false}
      styles={customStyles(isMobile)}
      onChange={(option) => onChange(option)}
      onBlur={(event) => event.preventDefault()}
      isMulti={isMulti}
    />
  );
};
const customStyles = (isMobile) => {
  return ({
    container: (provided) => ({
        ...provided,
        width: (isMobile ? '100%' : 320),
      }),
    control: (provided, state) => ({
      ...provided,
      minHeight: 20,
      height: (isMobile ? 33 : 32),
      cursor: 'pointer',
      transition: 'all 0.2s',
      boxShadow: 'none',
      border: `2px solid ${state.isFocused ? '#999999' : '#d6d2d8'}`,
      '&:hover': {
        border: `2px solid ${state.isFocused ? '#999999' : '#dbdbdb'}`,
      },
    }),

    valueContainer: (provided) => ({
      ...provided,
      top: -1,
      height: 30,
      padding: '0px 7px',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: 30,
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: 0,
      fontSize: 14,
      fontWeight: 400,
      color: '#8a8695',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#999999',
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: 2,
      marginBottom: 0,
      borderRadius: 3,
      boxShadow: '0 0 0 1px rgba(68, 68, 68, 0.11)',
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
      minHeight: 30,
      paddingLeft: 18,
      paddingRight: 29,
      fontSize: 14,
      fontWeight: state.isSelected ? 'bold' : 400,
      color: '#8a8695',
      transition: 'all 0.2s',
      cursor: 'pointer',
      backgroundColor: state.isFocused && '#f6f6f6',
      '&:active': {
        backgroundColor: '#f6f6f6',
      },
    }),
  });
};

Select.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object.isRequired),
  isMobile: PropTypes.bool,
  value: PropTypes.arrayOf(PropTypes.object).isRequired,
  placeholder: PropTypes.string,
  isMulti: PropTypes.bool,
};

Select.defaultProps = {
  options: [],
  placeholder: '',
  isMulti: false,
  isMobile: true,
};

export default Select;
